var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNetwork = function SvgNetwork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M29.5 18a9.36 9.36 0 0 1 7.5 3.75M2 21.75A9.36 9.36 0 0 1 9.5 18M19.5 28a6.25 6.25 0 1 0 0-12.5 6.25 6.25 0 0 0 0 12.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M10.75 33a10.156 10.156 0 0 1 17.5 0M24.656 11.75A5 5 0 1 1 29.5 18M9.5 18a5 5 0 1 1 4.844-6.25"
  })));
};
export default SvgNetwork;